var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");

var CurrentUser = require("lib/account/CurrentUser");
var CoinDisplay = require("components/utility/CoinDisplay");
var FeedbackOverrideDisplay = require("components/utility/FeedbackOverrideDisplay");
var Tiers = require("lib/games/Tiers");
var SpeechControls = require("components/writing/questions/SpeechControls");

require("utility/owlfonso_container.scss");

class OwlfonsoContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		
		if (props.feedbackObj) {
			LuckyOrangeClient.tagComponent(`feedback_key:${props.feedbackObj.key}`)
		};

		this.state = { showOverrideOptions: false, hideRewardFeedback: false, children: props.children, showContent: !props.initialAnimation };
	}

	hideOwl() {
		var user = CurrentUser.get()
		return this.props.hideOwl || (user && user.settings && user.settings.hide_owls);
	}

	getFeedbackText() {
		return this.props.feedbackToRead;
	}

	isSpellingError() {
		return this.props.feedbackObj ? this.props.feedbackObj.key === SPELLING_ERROR_KEY : false;
	}
	// send reason for override back to parents and renders success message
	submitReason(reason, e) {
		$wr.nope(e)
		window.wrNotifications.triggerDropDownNotification({
			title: "Success!", text: "Thank you for your feedback!", icon: "star"
		});
		this.setState({ hideRewardFeedback: false, showOverrideOptions: false }, () => {
			this.props.onFeedbackOverride(this.props.feedbackObj, reason)
		})
	}
	// renders override option buttons or the feedback
	renderFeedbackOrOverrideOptions() {
		if (this.state.showOverrideOptions) {
			return (
				<div>
					<div className='reasonHeader'>Please help me understand why <span className='boldText'>{this.props.feedbackObj.trigger}</span> was spelled correctly.</div>
					<span><button className="btn btn-link buttonPrimary reasonBtn" onClick={this.submitReason.bind(this, 'PERSON_OR_PLACE')}>Person or Place Name</button></span><br />
					<span><button className="btn btn-link buttonPrimary reasonBtn" onClick={this.submitReason.bind(this, 'TEXT_VOCAB')}>Text-Specific Vocabulary</button></span><br />
					<span><button className="btn btn-link buttonPrimary reasonBtn" onClick={this.submitReason.bind(this, 'NON_ENGLISH_WORD')}>Non-English Word</button></span><br />
					<span><button className="btn btn-link buttonPrimary reasonBtn" onClick={this.submitReason.bind(this, 'OTHER')}>Other</button></span>
				</div>
			)
		} else {
			return this.state.children
		}
	}
	// manipulate display to show override options
	onFeedbackOverride() {
		this.setState({ showOverrideOptions: true, hideRewardFeedback: true })
	}

	render() {
		var owlWidth = this.props.owlWidth || 80;
		var bubbleClass = "suggestionBubble";
		var owlClass = "owlImg";
		var bubbleStyle = {};
		var owlStyle = { width: owlWidth };
		var user = CurrentUser.get()

		switch(this.props.owlPosition) {
			case "bottom-left":
				bubbleClass += " bottomLeft";
				owlClass += " bottomLeft";
				owlStyle["marginLeft"] = Math.max(38 - owlWidth * 0.2, 0);
				break;
			case "left-upper":
			default:
				bubbleClass += " leftUpper";
				owlClass += " leftUpper";
				bubbleStyle["marginLeft"] = owlWidth + 25;
				owlStyle["top"] = Math.max(40 - owlWidth * 0.2, 0);
				break;
		}

		if (!this.hideOwl()) {
			bubbleClass += " withArrow";
			var owlImg = (
				<img src={ require('owls/official-owlfonso.png') } className={ owlClass }
					style={ owlStyle } />
			);			
		}
		if (this.props.showFeedbackReward && !this.state.hideRewardFeedback && !this.isSpellingError()) {
			var coin_amount = Tiers.getQunitXValue("addressed_feedback", user.tier);
			var reward = (
				<div className="feedbackReward">
					Fix this and earn
					<CoinDisplay coins={coin_amount } height={ 20 } />
				</div>
			);
		}
		if (this.isSpellingError() && !this.state.hideRewardFeedback) {
			if (this.props.feedbackObj) {
				var overrideText = `"${this.props.feedbackObj.trigger}" is spelled correctly`
			} else {
				var overrideText = 'This word is spelled correctly'
			}
			var override = (
				<div className="feedbackOverride" onClick={this.onFeedbackOverride}>
					<p className="overrideLinkText">{overrideText}</p>
				</div>
			)
		}
		if (this.state.showContent) {
			var speechControlsPreference = CurrentUser.get().prefs.speech_controls;
			if (this.props.feedbackToRead && speechControlsPreference != "off" && !this.state.hideRewardFeedback) {
				var autoReadFeedback = speechControlsPreference == "voice-first";
				var readFeedbackControls = (
					<SpeechControls getTextToRead={ this.getFeedbackText } autoReadText={ autoReadFeedback }
						readTextOnly={ true } />
				);
			}
			var textBubble = (
				<CSSTransition classNames="bubble-animation"
					timeout={{ enter: 1500, exit: 300 }}>
					<div className={ bubbleClass } style={ bubbleStyle }>
						{ this.renderFeedbackOrOverrideOptions() }
						{ readFeedbackControls }
						{ reward }
						{ override }
					</div>
				</CSSTransition>
			);			
		}
		
		var suggestionSection = (
			<div>
				<div className="suggestionSection">
		        	<TransitionGroup>
						{ textBubble }
		        	</TransitionGroup>
		            { owlImg }
				</div>
			</div>
		)
		return (
			<div className="owlfonsoContainer">
				{ suggestionSection }
			</div>
		);
	}

	componentDidMount() {
		if (!this.state.showContent) {
			setTimeout(function() {
				this.setState({ showContent: true });
			}.bind(this), 20);
		}
	}
}

var SPELLING_ERROR_KEY = 'WRITE_GRAM_SPELLING'

OwlfonsoContainer.propTypes = StrictPropTypes({
	// Components to render inside the container
	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array,
		PropTypes.string,
		PropTypes.func
	]).isRequired,

	// Changes the position and the owl relative to the bubble
	// Default: left-upper
	owlPosition: PropTypes.string,

	// Changes the width of the owl
	// Default: 80
	owlWidth: PropTypes.number,

	// If true, causes the animation to show for the initial content
	// Default: false
	initialAnimation: PropTypes.bool,

	// If true, the owl won't be shown
	hideOwl: PropTypes.bool,

	// If true, show reward for taking feedback into account
	showFeedbackReward: PropTypes.bool,

	// Feedback text to read out loud
	feedbackToRead: PropTypes.string,

	onFeedbackOverride: PropTypes.func,
	feedbackObj: PropTypes.object,
});


module.exports = OwlfonsoContainer;


// WEBPACK FOOTER //
// ./modules/components/utility/OwlfonsoContainer.js